import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AssignToEvent, BulkAssignToEvent } from '../../models/assign.model';
import * as rootReducer from '../../state/_setup/reducers';
import * as assignActions from '../../state/assign/assign.actions';
import { SystemEventsFacade } from '../system-events/system-events-facade.service';
import { SystemEvent } from '../system-events/system-events.reducer';

@Injectable({
    providedIn: 'root',
})
export class AssignFacadeService {
    constructor(
        private store$: Store<rootReducer.State>,
        private systemEventsFacade: SystemEventsFacade,
    ) {}

    assignToEvent(assignToEvent: AssignToEvent): void {
        this.store$.dispatch(assignActions.assignTo(assignToEvent));
    }

    bulkAssignToEvent(bulkAssignToEvent: BulkAssignToEvent): void {
        this.store$.dispatch(assignActions.bulkAssignTo(bulkAssignToEvent));
    }

    getAssignToSuccessEvents$(): Observable<SystemEvent<Action>> {
        return this.systemEventsFacade.getEventsOfSourceActionTypes$<Action>([
            assignActions.assignToSuccess.type,
            assignActions.bulkAssignToSuccess.type,
        ]);
    }

    getAssignToFailureEvents$(): Observable<SystemEvent<Action>> {
        return this.systemEventsFacade.getEventsOfSourceActionTypes$<Action>([
            assignActions.assignToFailure.type,
            assignActions.bulkAssignToFailure.type,
        ]);
    }
}
